<template>
  <aside class="ed-aside">
    <slot></slot>
  </aside>
</template>

<script>
  export default {
    name: 'edAside',
    props: {
      trigger: String,
    },
    mounted() {
      if (document.getElementsByClassName(this.trigger)[0]) {
        document.getElementsByClassName(this.trigger)[0].addEventListener('click', (event) => {
          if (this.$el.classList.contains('open')) {
            this.$el.classList.remove('open');
          } else {
            this.$el.className += ' open';
          }
        });
      }
    }
  };
</script>



// WEBPACK FOOTER //
// edAside.vue?210df4ef